import React from 'react'
import { Box, Button, styled, Typography } from '@mui/material'
import QuickContacts from '../quickContacts/QuickContacts';
import { Download } from '@mui/icons-material';

const MainBox = styled(Box)(({theme}) => ({
    width: '100%',
    height: '28vh',
    // backgroundColor: '#c4feeb',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      height: '20vh'
    }
}));

const TitleBox = styled(Box)(({theme}) => ({
  marginTop: '4rem',
  marginBottom: 0,

  [theme.breakpoints.down('sm')]: {
    marginTop: '1rem',
  marginBottom: '-1rem',
  }
}));

const ContactBar = styled(Box)(({theme}) => ({
  width: '100%',
  height: '7vh',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2rem',
  color: 'white',
  backgroundColor: '#242424',
  
  [theme.breakpoints.down('sm')]: {
    height: '12vh',
    flexDirection: 'column',
    gap: 0,
  }
}));

const ButtonStyled = styled(Button)(({theme}) => ({
  height: '3vh',
  color: '#242424',
  backgroundColor: 'white',
  fontSize: '0.8rem',
  fontWeight: '600',
  paddingLeft: '0.7rem',
  paddingRight: '0.7rem',
  paddingTop: '0.4rem',
  
  [theme.breakpoints.down('md')]: {
    fontSize: '0.7rem',
    paddingTop: '0.5rem',
  }
}));

const C = styled(Box)(({theme}) => ({
  // height: '3vh',
}));

function TopSection({ SectionTitle }) {
  return (
    <MainBox>
      <TitleBox>
        <h1 fontWeight={600} sx={{ fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }} >{SectionTitle}</h1>
      </TitleBox>
      <ContactBar>
        <Box sx={{ height: '60%' }} >
          <QuickContacts/>
        </Box>
        <ButtonStyled variant='contained' ><Download sx={{ fontSize: { xs: '0.8rem', md: '0.9rem' }, mr: 1 }} />Download Sample Report</ButtonStyled>
      </ContactBar>  
    </MainBox>
  )
}

export default TopSection